import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";
import queryString from "query-string";
import BetterBox from "../../components/BetterBox";
import BetterAlerts from "../../components/BetterAlerts";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import CustomInput from "../../components/CustomInput";
import { toAbsoluteUrl } from "../../../_metronic";
import { resetPassword } from "../../crud/auth.crud";

class ResetPassword extends Component {
    constructor() {
        super();

        this.state = {
            token: "",
            email: "",
            password: "",
            confirm: "",
            loading: false,
            submitted: false,
        };
    }

    componentDidMount = () => {
        const params = queryString.parse(this.props.location.search, { decode: false });
        this.setState({ token: params.token, email: params.email });
    };

    onSubmit = () => {
        if (this.state.password !== this.state.confirm) {
            this.setState({ errors: ["As senhas não são iguais"] });
            return;
        }

        if (this.state.password.length < 6) {
            this.setState({ errors: ["Sua nova senha precisa ter no mínimo 6 caracteres."] });
            return;
        }

        this.setState({ submitted: true });
        resetPassword({ password: this.state.password, password_confirmation: this.state.confirm, token: this.state.token, email: this.state.email })
            .then(async (res) => {
                window.scrollTo(0, 0);

                if (res.data.error) {
                    this.setState({ submitted: false });

                    Swal.fire("Ops!", res.data.error, "error");
                } else {
                    await Swal.fire({
                        icon: "success",
                        title: "Tudo certo!",
                        text: "Sua senha foi redefinida com sucesso.",
                        showConfirmButton: false,
                        timer: 1500,
                    });

                    window.location.href = "/auth/login";
                }
            })
            .catch((e) => {
                this.setState({ submitted: false });

                Swal.fire("Ops!", "Parece que houve um problema ao enviar o e-mail. Por favor, entre em contato com o suporte.", "error");
            });
    };

    render() {
        return (
            <div style={{ margin: "50px 0px 50px 0px" }}>
                <div className="row" style={{ margin: "0" }}>
                    <div className="col-sm-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <div className="row">
                            <div className="col-sm-12">
                                <center>
                                    <img alt="Logo" src={toAbsoluteUrl("/images/logo-dark.png")} style={{ width: 150, height: "auto", marginBlock: 35 }} />

                                    <p style={{ padding: "10px 50px 15px 50px", fontSize: "18px", color: "#424242", fontWeight: "500" }}>
                                        <b>Olá!</b> Para recuperar seu acesso, digite a nova senha.
                                    </p>
                                </center>
                            </div>

                            <div className="col-sm-12">
                                <BetterCircularProgress loading={this.state.loading}>
                                    <div>
                                        <div className="col-sm-12" style={{ marginBottom: 24 }}>
                                            <BetterAlerts errors={this.state.errors} />
                                        </div>

                                        <div>
                                            <div className="col-sm-12">
                                                <BetterBox title="Digite sua nova senha">
                                                    <div className="col-sm-12">
                                                        <div className="form-group fg-line d-flex flex-column gap-24">
                                                            <CustomInput
                                                                required
                                                                margin="normal"
                                                                inheritLabel
                                                                value={this.state.password}
                                                                label="Senha"
                                                                name="password"
                                                                handleChange={(e) => {
                                                                    this.setState({ errors: [] });
                                                                    this.setState({ password: e.target.value });
                                                                }}
                                                                disabled={this.state.submitted}
                                                            />
                                                            <CustomInput
                                                                required
                                                                margin="normal"
                                                                inheritLabel
                                                                value={this.state.confirm}
                                                                label="Confirmar senha"
                                                                name="confirm_password"
                                                                handleChange={(e) => {
                                                                    this.setState({ errors: [] });
                                                                    this.setState({ confirm: e.target.value });
                                                                }}
                                                                disabled={this.state.submitted}
                                                            />
                                                        </div>
                                                    </div>
                                                </BetterBox>
                                            </div>

                                            <div className="col-sm-12">
                                                <div className="d-flex justify-content-between">
                                                    <Link to="/auth/login" className="btn btn-primary btn-large tt-14 semibold">
                                                        Voltar
                                                    </Link>

                                                    <Button className="btn btn-success btn-large tt-14 semibold d-flex align-items-center" onClick={() => this.onSubmit()} disabled={this.state.submitted}>
                                                        <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>Salvar
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </BetterCircularProgress>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, null)(ResetPassword);
